import { toast } from '@zerodevx/svelte-toast';

export const toast_message = (status, msg, time) => {
	if (status) {
		toast.push(msg, {
			duration: time,
			dismissable: false,
			theme: {
				'--toastBackground': '#48BB78',
				'--toastProgressBackground': '#2F855A'
			}
		});
	} else {
		toast.push(msg, {
			duration: time,
			dismissable: false,
			theme: {
				'--toastBackground': '#F56565',
				'--toastProgressBackground': '#C53030'
			}
		});
	}
}